import React from 'react'
const SingleLineList = () => (
  <ul className="list-group">
    <li className="list-group-item">Text only</li>
    <li className="list-group-item active">Active item</li>
    <li className="list-group-item disabled">Disabled item</li>
  </ul>
)
export default SingleLineList



// WEBPACK FOOTER //
// ./src/ui-elements/lists/SingleLineList.js